import './App.css';
import {BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useEffect, lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import StorePrivacyPolicy from './StorePrivacyPolicy';

import TotpList from './totp/TotpList';
import TotpEdit from './totp/TotpEdit';

import Guide from './totp/sidemenu/Guide';
import Manual from './totp/sidemenu/Manual';
import About from './totp/sidemenu/About';
import PrivacyPolicy from './totp/sidemenu/PrivacyPolicy';
import FileBoard from './totp/sidemenu/FileBoard';
import Settings from './totp/sidemenu/Settings';



import { parseDeviceToken, getLanguageFromRegion } from './common/TokenUtil';
import authService from './linkto/authService';

const LinkMain = lazy(() => import('./linkto/LinkMain'));
const LinkLogin = lazy(() => import('./linkto/LinkLogin'));
const LinkSignup = lazy(() => import('./linkto/LinkSignup'));

function LinkPrivateRoute({ children }) {
  const authState = authService.isLoggedIn() ? 'authenticated' : 'unauthenticated';

  if (authState === 'unauthenticated') {
    return <Navigate to="/linkto/login" replace />;
  }
  return children;
}

function App() {

  const { i18n } = useTranslation();

  useEffect(() => {
    // 이전 저장된 토큰을 활용하여 초기 언어 설정 (앱이 처음 로드될 때)
    const token = parseDeviceToken();
    if (token && token.language_code) {
      i18n.changeLanguage( token.language_code);
    }
  }, []);

  console.log("-------------- Load APP --------------")
  return (
    <BrowserRouter>
    <div className="App">

      <Routes>
        {/* 개인정보 처리방침(외부접근 가능함) */}
        <Route path="/privacy-policy" element={<StorePrivacyPolicy/>} />

        {/* 기본 라우트 (확장자 없음) */}
        <Route path="/vtotp/otp-list" element={<TotpList/>} />
        <Route path="/vtotp/otp-edit" element={<TotpEdit/>} />

        {/* 사이드 메뉴 항목들 */}
        <Route path="/vtotp/guide" element={<Guide/>} />
        <Route path="/vtotp/manual" element={<Manual/>} />
        <Route path="/vtotp/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/vtotp/about" element={<About/>} />
        <Route path="/vtotp/file-board" element={<FileBoard/>} />
        <Route path="/vtotp/settings" element={<Settings/>} />

        {/* /, /vtotp/ 접속 시 기본 페이지로 리다이렉트 */}
        <Route path="/" element={<Navigate to="/vtotp/otp-list" replace />} />
        <Route path="/vtotp/" element={<Navigate to="/vtotp/otp-list" replace />} />

        {/* 로그인, 회원가입, 채팅 메뉴 */}
        <Route path="/linkto/login" element={<Suspense fallback={null}><LinkLogin/></Suspense>} />
        <Route path="/linkto/signup" element={<Suspense fallback={null}><LinkSignup/></Suspense>} />
        <Route path="/linkto/linkmain" element={<Suspense fallback={null}><LinkPrivateRoute><LinkMain/></LinkPrivateRoute></Suspense>} />

        {/* /linkto/ 접속 시 기본 페이지로 리다이렉트 */}
        <Route path="/linkto/" element={<Navigate to="/linkto/login" replace />} />


      </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
